import { t } from 'i18next'
import React, { useContext, useEffect } from 'react'
import SpecialistPage from '../Specialist/SpecialistPage'
import PublicContext from '../PublicContext'

export default function BoxSpecialistSlotList () {
  const { setSiderTitle } = useContext(PublicContext)

  useEffect(() => {
    setSiderTitle(t('Public.BoxPage.title'))
  }, [])

  return (
    <SpecialistPage />
  )
}
